// libraries
import React from 'react'
// components
import Toast from '../Toast/Toast'
// styles
import styles from './ToastList.module.scss'
import {useToasts} from "@/components/ToastProvider/ToastProvider";

type Props = unknown

const ToastList: React.FC<Props> = () => {
  const [toasts] = useToasts()

  return (
    <div className={styles.toastListContainer}>
      {toasts.map((toast) => (
        <Toast toast={toast} key={toast.id} />
      ))}
    </div>
  )
}

export default ToastList
